import ApiService from "@/common/api/api.service";

const AnoLetivoService = {
  async pegarTodos() {
    let { data } = await ApiService.get("AnoLetivo");
    return data;
  },
  async listar(paginacao) {
    let { data } = await ApiService.get(`AnoLetivo`, { params: paginacao });
    return data;
  },
  async buscarPorId(id) {
    let { data } = await ApiService.get(`AnoLetivo/${id}`);
    return data;
  },
  async buscarPorIdComSegmentacao(id) {
    let { data } = await ApiService.get(`AnoLetivo/obter-lista-segmentacoes`, {
      params: { id },
    });
    return data;
  },
  async obterPeriodoLetivo() {
    let { data } = await ApiService.get(
      `AnoLetivo/portal-aluno-obter-periodo-letivo`
    );
    data.data = data.data.map((row) => ({
      ...row,
      text: row.ano,
      value: row.id,
    }));
    return data;
  },
};

export default AnoLetivoService;
